import {FAVORITE_TEMPLATE, INIT_FAVORITES} from './constants';

const initialState = {
  favorites: [],
};

export const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case INIT_FAVORITES: {
      const {favorites} = action.payload;

      return {
        ...state,
        favorites,
      };
    }

    case FAVORITE_TEMPLATE: {
      const {name} = action.payload;

      let {favorites} = state;
      favorites = [...favorites];
      if (!favorites.includes(name)) {
        favorites.push(name);
        window.favoritesNumber++;
      } else {
        favorites = favorites.filter((n) => n !== name);
        window.favoritesNumber--;
      }
      return {...state, favorites};
    }

    default: {
      return state;
    }
  }
};
